/**
 *
 */
export enum SearchView {
  Empty = 0,
  List = 1,
  Map = 3,
  Favorite = 4,
}
